import { useLanguage } from "../context/LanguageContext";
import { Reveal } from "./Reveal";

export const Approach = () => {
  const { t } = useLanguage();

  return (
    <section id="abordagem" className="border-t border-white/10 bg-surface/40 py-28 sm:py-36" data-testid="approach-section">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.35em] text-terracotta">
            {t.approach.eyebrow}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="max-w-2xl font-display text-2xl font-normal leading-snug tracking-tight text-sand sm:text-3xl lg:text-4xl" data-testid="approach-title">
            {t.approach.title}
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <blockquote
            className="mt-12 max-w-3xl border-l-2 border-terracotta pl-6 font-display text-lg italic leading-relaxed text-sand/85 sm:text-xl"
            data-testid="approach-quote"
          >
            {t.approach.quote}
          </blockquote>
        </Reveal>

        <div className="mt-16 grid gap-px overflow-hidden rounded-xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-testid="approach-principles">
          {t.approach.principles.map((principle, i) => (
            <Reveal key={principle.n} delay={0.08 + i * 0.08} y={24} className="h-full">
              <div
                className="group flex h-full flex-col bg-basalt p-8 transition-colors duration-500 hover:bg-surface"
                data-testid={`approach-principle-${principle.n}`}
              >
                <span className="font-mono text-sm text-terracotta transition-transform duration-500 group-hover:-translate-y-1">
                  {principle.n}
                </span>
                <h3 className="mt-14 font-display text-xl text-sand sm:text-2xl">{principle.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-mist">{principle.desc}</p>
                <span className="mt-auto block pt-8">
                  <span className="block h-px w-8 bg-white/20 transition-all duration-500 group-hover:w-full group-hover:bg-terracotta" />
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
